class CustomerImpersonation
{
  constructor (app)
  {
    this.cookieName = 'shopify_customer_impersonation';
    this.impersonationData = null;
    this.app = app;
    this.impersonationBar = null;
    this.checkQueryParams();
    this.loadFromCookie();
    this.updateImpersonationBar();
  }

  checkQueryParams ()
  {
    const urlParams = new URLSearchParams(window.location.search);
    const customerId = urlParams.get('impersonate_customer_id');
    const customerHash = urlParams.get('impersonate_customer_hash');

    if (customerId && customerHash) {
      this.setImpersonation(customerId, customerHash);

      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

  setImpersonation (customerId, customerHash)
  {
    this.impersonationData = {
      customerId: customerId,
      customerHash: customerHash
    };

    this.app.setCookie(this.cookieName, JSON.stringify(this.impersonationData));
    this.updateImpersonationBar();
  }

  loadFromCookie ()
  {
    if (this.impersonationData) {
      return;
    }

    const cookieValue = this.app.getCookie(this.cookieName);

    if (cookieValue) {
      try {
        this.impersonationData = JSON.parse(cookieValue);
      } catch (e) {
        this.clearImpersonation();
      }
    }
  }

  clearImpersonation ()
  {
    this.impersonationData = null;
    this.app.removeCookie(this.cookieName);
    this.updateImpersonationBar();
  }

  isActive ()
  {
    return this.impersonationData !== null;
  }

  getCustomerId ()
  {
    return this.isActive() ? this.impersonationData.customerId : null;
  }

  getCustomerHash ()
  {
    return this.isActive() ? this.impersonationData.customerHash : null;
  }

  updateImpersonationBar ()
  {
    if (this.isActive()) {
      this.showImpersonationBar();
    } else {
      this.hideImpersonationBar();
    }
  }

  showImpersonationBar ()
  {
    if (this.impersonationBar) {
      return;
    }

    this.impersonationBar = document.createElement('div');
    this.impersonationBar.id = 'shopify-impersonation-bar';
    this.impersonationBar.innerHTML = `
      <div style="
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #ff4444;
        color: white;
        padding: 12px 16px;
        border-radius: 8px;
        font-family: Arial, sans-serif;
        font-size: 13px;
        font-weight: bold;
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 8px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
        max-width: 280px;
      ">
        <span>🎭 IMPERSONATING CUSTOMER ID: ${this.impersonationData.customerId}</span>
        <button id="leave-impersonation" style="
          background: rgba(255,255,255,0.2);
          border: 1px solid white;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          align-self: flex-end;
        ">LEAVE</button>
      </div>
    `;

    document.body.appendChild(this.impersonationBar);

    const leaveButton = document.getElementById('leave-impersonation');
    leaveButton.addEventListener('click', () => {
      this.clearImpersonation();
      window.location.reload();
    });
  }

  hideImpersonationBar ()
  {
    if (this.impersonationBar) {
      this.impersonationBar.remove();
      this.impersonationBar = null;
    }
  }
}